/* import __COLOCATED_TEMPLATE__ from './collapsed-objectives.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { TrackedAsyncData } from 'ember-async-data';
let SessionCollapsedObjectivesComponent = (_class = class SessionCollapsedObjectivesComponent extends Component {
  get objectivesData() {
    return new TrackedAsyncData(this.args.session.sessionObjectives);
  }
  get objectives() {
    return this.objectivesData.isResolved ? this.objectivesData.value : [];
  }
  get objectivesWithParents() {
    return this.objectives.filter(objective => {
      return objective.hasMany('courseObjectives').ids().length > 0;
    });
  }
  get objectivesWithMesh() {
    return this.objectives.filter(objective => {
      return objective.hasMany('meshDescriptors').ids().length > 0;
    });
  }
  get objectivesWithTerms() {
    return this.objectives.filter(objective => {
      return objective.hasMany('terms').ids().length > 0;
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "objectivesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "objectivesData"), _class.prototype), _class);
export { SessionCollapsedObjectivesComponent as default };